<template>
  <el-dialog
    class="ap-recover-silence"
    title="申请恢复沉默"
    :visible.sync="dialogShow"
    width="900px"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    append-to-body
    :before-close="close"
  >
    <div v-if="step == 0" class="flex justify-content-center" >
      <div v-if="!importLoading" class="flex" style="width:670px;margin: 30px auto;">
        <div class="hd" style="width: 400px;line-height: 1.8;">
          <div class="font-2x text-bold mt-md">通电测试</div>
          <div class="mt-lg">功能介绍</div>
          <div class="mt-sm text-muted">设备出厂前短暂通电测试被激活，测试结束后，可申请重新恢复至沉默状态。该功能每个接入点仅可使用一次。</div>
          <div class="mt-lg">设备须同时满足以下条件：</div>
          <div class="mt-sm text-muted">
            1、通电激活后，30日内发起申请；<br />
            2、通电测试已结束，设备已离线；<br />
            3、未超出沉默截止期
          </div>
          <el-button type="success" class="mt-lg" @click="importEquip()">导入设备</el-button>
        </div>
        <div class="bd"></div>
        <div class="ft preview">
          <img :src="slience_url" style="width: 250px;height: 250px;margin: 50px 0 0 0;transform: translateX(50px);">
        </div>
      </div>
      <div v-else-if="importLoading" class="flex-center column" style="height: 493px;">
        <img class="parse-img" src="@/assets/parse.gif" />
        <div class="font-md">正在导入数据······</div>
      </div>
    </div>
    <el-alert v-if="step == 1" type="warning" show-icon class="mb-lg" :closable="false" style="margin-top: -15px;">
      <div slot="title" class="flex">
        每个接入点仅能申请一次恢复沉默，请谨慎使用！申请前，请确保设备已断电离线。
      </div>
    </el-alert>
    <div v-loading="loading" v-if="step == 1">
      <div v-if="loading_result" style="font-size: 18px;" class="mt mb">
        处理完成
        <span v-if="success_num">
          ，成功
          <span class="text-success">{{ success_num }}</span> 个
        </span>
        <span v-if="success_num && fail_num">，</span>
        <span v-if="fail_num">
          <span v-if="!success_num">，</span>
          失败
          <span class="text-danger">{{ fail_num }}</span> 个
        </span>
      </div>
      <el-scrollbar :native="false" ref="apScrollbar">
        <el-table v-if="list.length" ref="silenceTable" :data="list" tooltip-effect="dark">
          <el-table-column type="index" width="60" label="#" />
          <el-table-column label="接入点/设备" min-width="140">
            <template slot-scope="scope">
              <div>{{ scope.row.simid }}</div>
              <div class="text-muted" style="height: 15px;line-height: 15px;font-size: 12px">{{ scope.row.equip_name }}</div>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="激活时间" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.first_activation | parseTime('{y}/{m}/{d}') }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="恢复沉默至" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.silent_deadline | parseTime('{y}/{m}/{d}') }}</span>
            </template>
          </el-table-column>

          <el-table-column label="结果" min-width="160" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.loading" class="text-warning">
                正在处理中<i class="el-icon-loading ml-xs" style="font-size: 16px;"></i>
              </span>
              <span v-else :class="scope.row.status == 1 ? 'text-green' : 'text-danger'">{{scope.row.status == 1 ? "成功" : scope.row.err_message }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-else class="flex column align-items-center justify-content-center" style="height: 320px;padding-top: 30px;">
          <img src="@/assets/no-data.png" style="width: 200px;height: 200px;" />
        </div>
      </el-scrollbar>
    </div>
    <span v-if="step != 0" slot="footer" class="dialog-footer flex justify-content-center">
      <el-button v-if="!start_transfer && !loading_result" @click="closeDialog" class="extend">{{list.length ? '取消' : '关闭'}}</el-button>
      <el-button v-if="!start_transfer && !loading_result && list.length" type="primary" class="extend" @click="submit">开始</el-button>
      <span v-if="start_transfer && !loading_result" class="text-warning">
        正在处理中，已完成 {{ finish_num }} / {{ list.length }}
        <span class="ml-sm el-icon-loading" style="font-size: 16px;color: #f0ad4e"></span>
      </span>
      <el-button v-if="loading_result && success_num == list.length" type="primary" class="extend" plain @click="continueShare">继续分享</el-button>
      <el-button v-if="loading_result" class="extend" @click="closeDialog">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { apSilentRecoverApi, apTestingGetallApi } from "@/api/ap/apApi";

export default {
  name: "ApRecoverSilence",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    simids: {
      type: Array,
      default: () => [],
    },
    silenceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: [],
      start_transfer: false,
      loading_result: false,
      success_num: 0,
      fail_num: 0,

      loading: false,
      finish_num: 0,
      step: 0,
      importLoading: false,
      shareEquips: [],
      slience_url: 'https://res.frippler.com/global/asst/return-silence.png',
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  created() {
    const temp = this.silenceList;
    if(this.silenceList.length) {
      this.step = 1;
      this.list = temp.map((item) => {
        return {
          ...item,
          loading: false,
          status: 0,
          err_message: null,
          simid: item.simid,
          equip_name: item.equip_name,
          first_activation: item.first_activation,
          silent_deadline: item.silent_deadline,
        }
      })
    }
  },
  methods: {
    importEquip() {
      this.importLoading = true
      apTestingGetallApi().then((res) => {
        this.importLoading = false;
        if(!res.errno) {
          const tempArr = res.data.list
          if(tempArr.length && tempArr.length >= 100) {
            tempArr = tempArr.slice(0, 100); // 最多导入100个
          }
          this.list = tempArr.map((item) => {
            return {
              ...item,
              loading: false,
              status: 0,
              err_message: null,
              simid: item.simid,
              equip_name: item.sim_go,
              first_activation: item.first_activation,
              silent_deadline: item.silent_deadline,
            }
          })
          this.step = 1;
        } else {
          this.$message.error(res.message);
        }
      })
    },


    async submit() {
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      for (let i = 0; i < this.list.length; i++) {
        this.start_transfer = true;
        this.list[i].loading = true;
        const res = await apSilentRecoverApi({
          simid: this.list[i].simid,
        });
        await delay(1000);

        this.list[i].loading = false;
        this.finish_num += 1;

        if (!res.errno) {
          this.list[i].status = 1;
        } else {
          this.list[i].err_message = res.message;
        }
        // this.list[i].status = 1;

        if (this.finish_num > 5) {
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
        if (i == this.list.length - 1) {
          this.start_transfer = false;
          this.loading_result = true;
          this.success_num = 0;
          this.fail_num = 0;
          for (let j = 0; j < this.list.length; j++) {
            if (this.list[j].status == 1) {
              this.success_num++;
            } else {
              this.fail_num++;
            }
          }
        }
      }
      this.$emit("change");
    },

    scrollToBottom() {
      const scrollbar = this.$refs.apScrollbar;
      if (scrollbar) {
        scrollbar.wrap.scrollTop = scrollbar.wrap.scrollHeight;
      }
    },

    continueShare() {
      this.shareEquips = this.list.filter((item) => item.status == 1).map(item => {
        item.user_auth = item.auth_level
        item.name = item.equip_name
        item.go = item.sim_go
        if(!item.equipid) {
          item.equipid = item.sim_equipid
        }
        return item
      });

      this.$emit('share', this.shareEquips);
      this.closeDialog();
    },

    closeDialog() {
      this.dialogShow = false;
      this.activeid = null;
      this.loading_result = false;
      this.success_num = 0;
      this.fail_num = 0;
      this.start_transfer = false;
      this.finish_num = 0;
      this.list = [];
      this.step = 0;
      this.$emit('close')
    },

    close() {
      if(this.start_transfer) {
        this.$confirm('正在恢复中，请耐心等待加载完成', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        return false
      }
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.ap-recover-silence {
  .el-scrollbar {
    height: 420px;
    > .el-scrollbar__wrap {
      overflow-x: hidden;
      > .el-scrollbar__view {
        padding: 0 10px 20px 0;
      }
    }
  }
  .el-dialog__body {
    padding: 20px 60px;
  }
  .el-dialog__footer {
    padding-bottom: 30px;
  }
  .search {
    width: 220px;
  }
  .preview {
    width: 250px;
    height: 250px;
  }
  .parse-img {
    height: 194px;
  }
}
</style>
